// import React from "react";

// const WideRangeSection = () => {
//   return (
//     <div
//       className="section-full p-t150 p-b120 site-bg-white twm-w-range-section-wrap wow fadeInDown"
//       data-wow-offset="100"
//       data-wow-delay="0.2"
//     >
//       <div className="container">
//         {/* TITLE START */}
//         <div className="section-head center">
//           <div className="twm-sm-title left">
//             Find your car by car brand
//           </div>
//           <h2 className="twm-large-title site-text-dark">
//             Wide Range Of Commercial
//             <br />
//             And Luxury Cars
//           </h2>
//         </div>
//         {/* TITLE END */}

//         <div className="section-content">
//           <div className="row twm-w-range-section">
//             {/* One Block */}
//             <div className="col-lg-3 col-md-6 col-sm-6">
//               <div className="twm-cntr-with-icon">
//                 <div className="icon-media">
//                   <img src="images/icons/rental.png" alt="Client Served" />
//                 </div>
//                 <span className="counter">4500</span>{" "}
//                 <em className="symble">+</em>
//                 <h3 className="icon-content-info">Client Served</h3>
//               </div>
//             </div>

//             {/* Two Block */}
//             <div className="col-lg-3 col-md-6 col-sm-6">
//               <div className="twm-cntr-with-icon">
//                 <div className="icon-media">
//                   <img src="images/icons/man.png" alt="Happy Customers" />
//                 </div>
//                 <span className="counter">2750</span>{" "}
//                 <em className="symble">+</em>
//                 <h3 className="icon-content-info">Happy Customers</h3>
//               </div>
//             </div>

//             {/* Three Block */}
//             <div className="col-lg-3 col-md-6 col-sm-6">
//               <div className="twm-cntr-with-icon">
//                 <div className="icon-media">
//                   <img
//                     src="images/icons/car-insurance.png"
//                     alt="Vehicle In Stock"
//                   />
//                 </div>
//                 <span className="counter">600</span>{" "}
//                 <em className="symble">+</em>
//                 <h3 className="icon-content-info">Vehicle In Stock Cars</h3>
//               </div>
//             </div>

//             {/* Four Block */}
//             <div className="col-lg-3 col-md-6 col-sm-6">
//               <div className="twm-cntr-with-icon">
//                 <div className="icon-media">
//                   <img
//                     src="images/icons/work-time.png"
//                     alt="Years Experience"
//                   />
//                 </div>
//                 <span className="counter">12</span>{" "}
//                 <em className="symble">+</em>
//                 <h3 className="icon-content-info">Years Experience</h3>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WideRangeSection;


import React from "react";

const WideRangeSection = () => {
  return (
    <div
      className="section-full py-3 site-bg-white twm-w-range-section-wrap wow fadeInDown"
      data-wow-offset="100"
      data-wow-delay="0.2"
    >
      <div className="container">
        {/* TITLE START */}
        <div className="section-head center">
          <div className="twm-sm-title left">
            Why Choose Trustline Travels
          </div>
          <h2 className="twm-large-title site-text-dark">
           Safe & Reliable Travel Solutions
          </h2>
        </div>
        {/* TITLE END */}

        <div className="section-content">
          <div className="row twm-w-range-section">
            {/* One Block */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img src="images/icons/rental.png" alt="Trips Completed" />
                </div>
                <span className="counter">5000</span>
                <em className="symble">+</em>
                <h3 className="icon-content-info">Client Served</h3>
              </div>
            </div>

            {/* Two Block */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img src="images/icons/man.png" alt="Happy Travelers" />
                </div>
                <span className="counter">3500</span>
                <em className="symble">+</em>
                <h3 className="icon-content-info">Happy Travelers</h3>
              </div>
            </div>

            {/* Three Block */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img
                    src="images/icons/car-insurance.png"
                    alt="Premium Vehicles"
                  />
                </div>
                <span className="counter">100</span>
                <em className="symble">+</em>
                <h3 className="icon-content-info">Premium Vehicles</h3>
              </div>
            </div>

            {/* Four Block */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img
                    src="images/icons/work-time.png"
                    alt="Years of Experience"
                  />
                </div>
                <span className="counter">15</span>
                <em className="symble">+</em>
                <h3 className="icon-content-info">Years Experience</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WideRangeSection;